import GridDuck from 'gridduck';
export default async function GetNames(asyncQuery, itemIds, nameField) {
    let namePromises = itemIds.map(id =>
        GridDuck[asyncQuery]({ id: id }).then(item => {
            return item[nameField || 'name'];
        })
    );
    return await Promise.all(namePromises);
}